module.exports = __webpack_public_path__ + "static/img/MTI-Economy-C-便携式.c9709cf7.jpg";